import React from "react";
import SignupPage from "../../components/auth/SignupPage";

const SignupApplicant = () => {
  return <SignupPage />;
};

export default SignupApplicant;
